import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons, FooterError } from '@/design_system/Footer';
import { useValidateCustoms } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticleActionProps } from './ArticleActions';

export const AddCustomsInformationsAction = ({ onActionDone }: ArticleActionProps) => {
  const { t } = useLingui();
  const { article, state, hasError } = useArticleContext();

  const { mutateAsync: validateCustoms, isPending: isValidateCustomsPending } = useValidateCustoms({
    articleId: article.id,
  });

  const [apiError, setApiError] = useState<string | null>(null);

  const handleValidateCustoms = async () => {
    setApiError(null);

    const { hasError } = state.errors.check({
      customs: true,
    });

    if (hasError) {
      return;
    }

    try {
      await validateCustoms();
      onActionDone();
    } catch (err: any) {
      console.error(err);
      setApiError(
        (err.message as string) ?? t({ id: '_general.error.unknown', message: 'Unknown error' })
      );
    }
  };

  return (
    <>
      <Footer>
        {(hasError || apiError) && (
          <FooterError>
            {hasError ? (
              <Trans id="article.actions.add_customs_informations.errors">
                Please fill the missing information in order to validate the task
              </Trans>
            ) : (
              apiError
            )}
          </FooterError>
        )}
        <FooterButtons>
          <Button
            variant="primary"
            size="medium"
            onPress={handleValidateCustoms}
            isLoading={isValidateCustomsPending}
          >
            <Trans id="article.actions.add_customs_informations">Validate task</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </>
  );
};
